import React, { lazy } from 'react';
const Layout = lazy(() => import('../Layout/index.jsx'));
// import ShoppingMall from "../pages/shoppingMall";
const ShoppingMall = lazy(() => import('../pages/shoppingMall'));
// import ShopCar from "../pages/shopCar";
const ShopCar = lazy(() => import('../pages/shopCar'));

// import Sucess from "../pages/success";
const Sucess = lazy(() => import('../pages/success'));
const OrderSucess = lazy(() => import('../pages/success/order'));
// import Vehicle from "../pages/vehicle";
const Vehicle = lazy(() => import('../pages/vehicle'));

// import DetailsVehicle from "../pages/detailsVehicle";
const DetailsVehicle = lazy(() => import('../pages/detailsVehicle'));

// import VehicleOrder from "../pages/vehicleOrder";
const VehicleOrder = lazy(() => import('../pages/vehicleOrder'));

// import Tyre from "../pages/tyre/tyre.jsx";
const Tyre = lazy(() => import('../pages/tyre/tyre.jsx'));

// import DetailsTyre from "../pages/detailsTyre";
const DetailsTyre = lazy(() => import('../pages/detailsTyre'));

// import TyreOrder from "../pages/tyreOrder";
const TyreOrder = lazy(() => import('../pages/tyreOrder'));

// import Promotion from "../pages/Promotion";
const Promotion = lazy(() => import('../pages/Promotion'));

// import PromotionDetail from "../pages/PromotionDetail/index";
const PromotionDetail = lazy(() => import('../pages/PromotionDetail/index'));

// import DetailsUrea from "@/pages/detailsUrea";
const DetailsUrea = lazy(() => import('@/pages/detailsUrea'));

// import DetailsLubricants from "@/pages/detailsLubricants";
const DetailsLubricants = lazy(() => import('@/pages/detailsLubricants'));

// import LubricantsOrder from "@/pages/LubricantsOrder";
const LubricantsOrder = lazy(() => import('@/pages/LubricantsOrder'));

// import SearchVehicle from "@/pages/searchVehicle/index.jsx";
const SearchVehicle = lazy(() => import('@/pages/searchVehicle/index.jsx'));

// import SearchTyre from "@/pages/searchTyre/index.jsx";
const SearchTyre = lazy(() => import('@/pages/searchTyre/index.jsx'));

// import VehicleParameters from "@/pages/vehicleParameters/index";
const VehicleParameters = lazy(() => import('@/pages/vehicleParameters/index'));

// import IntentionList from "@/pages/IntentionList";
const IntentionList = lazy(() => import('@/pages/IntentionList'));

// import OrderDetails from "@/pages/orderDetails/index.jsx";
const OrderDetails = lazy(() => import('@/pages/orderDetails/index.jsx'));

// import Logistics from "@/pages/Logistics";
const Logistics = lazy(() => import('@/pages/Logistics'));

// import Rent from "@/pages/rent/index";
const Rent = lazy(() => import('@/pages/rent/index'));

// import Fill from "@/pages/Fill/index.jsx";
const Fill = lazy(() => import('@/pages/Fill/index.jsx'));

// import SuccessTwo from "@/pages/successTwo/index";
const SuccessTwo = lazy(() => import('@/pages/successTwo/index'));

// import Finance from "@/pages/finance/index";
const Finance = lazy(() => import('@/pages/finance/index'));

// import DyFactoring from "@/pages/dyFactoring/index";
const DyFactoring = lazy(() => import('@/pages/dyFactoring/index'));

// import DyLease from "@/pages/dyLease/index";
const DyLease = lazy(() => import('@/pages/dyLease/index'));

// import Insurance from "@/pages/Insurance/index";
const Insurance = lazy(() => import('@/pages/Insurance/index'));

// import MyPolicy from "@/pages/myPolicy/index";
const MyPolicy = lazy(() => import('@/pages/myPolicy/index'));

// import HistoryPolicy from "@/pages/historyPolicy/index";
const HistoryPolicy = lazy(() => import('@/pages/historyPolicy/index'));

// import Order from "../pages/order/index";
const Order = lazy(() => import('../pages/order/index'));

// import ModifyInformation from "@/pages/modifyInformation/index";
const ModifyInformation = lazy(() => import('@/pages/modifyInformation/index'));

// import SettlementOfClaims from "@/pages/settlemenOfClaims/index";
const SettlementOfClaims = lazy(() =>
  import('@/pages/settlemenOfClaims/index'),
);

// import ApplyOne from "@/pages/applyOne/index";
const ApplyOne = lazy(() => import('@/pages/applyOne/index'));

// import ApplyTwo from "@/pages/applyTwo/index";
const ApplyTwo = lazy(() => import('@/pages/applyTwo/index'));

// import ClaimRecords from "@/pages/ClaimRecords/index";
const ClaimRecords = lazy(() => import('@/pages/ClaimRecords/index'));

// import PolicyDetails from "@/pages/PolicyDetails/index";
const PolicyDetails = lazy(() => import('@/pages/PolicyDetails/index'));

// import SuccessThree from "@/pages/successThree/index";
const SuccessThree = lazy(() => import('@/pages/successThree/index'));

// import ImgShow from "../pages/imgShow/ImgShow";
const ImgShow = lazy(() => import('../pages/imgShow/ImgShow'));

// import ClaimRecordsTwo from "@/pages/claimRecordsTwo/index";
const ClaimRecordsTwo = lazy(() => import('@/pages/claimRecordsTwo/index'));

// import basicInformation from "../pages/basicInformation/index";
const basicInformation = lazy(() => import('../pages/basicInformation/index'));

// import basicInformationTwo from "../pages/basicInformationTwo/index";
const basicInformationTwo = lazy(() =>
  import('../pages/basicInformationTwo/index'),
);

// import DrivingInsurance from "@/pages/DrivingInsurance/index";
const DrivingInsurance = lazy(() => import('@/pages/DrivingInsurance/index'));

// import PolicyDetailsTwo from "@/pages/policyDetailsTwo/index";
const PolicyDetailsTwo = lazy(() => import('@/pages/policyDetailsTwo/index'));

// import SearchAll from "../pages/SearchAll/index";
const SearchAll = lazy(() => import('../pages/SearchAll/index'));

// import Parameter from "../pages/Parameter";
const Parameter = lazy(() => import('../pages/Parameter'));

// import Activity from "../pages/activity";
const Activity = lazy(() => import('../pages/activity'));

// import Bless from "@/components/Bless/index.jsx";
const Bless = lazy(() => import('@/components/Bless/index.jsx'));

// import Privacy from '../pages/Privacy/index'
const Privacy = lazy(() => import('../pages/Privacy/index'));

// import SdkPage from '../pages/SdkPage/SdkPage'
const SdkPage = lazy(() => import('../pages/SdkPage/SdkPage'));

// import CertificationOptions from '../pages/CertificationOptions/index'
const CertificationOptions = lazy(() =>
  import('../pages/CertificationOptions/index'),
);

// import PersonalCertification from '../pages/PersonalCertification/index'
const PersonalCertification = lazy(() =>
  import('../pages/PersonalCertification/index'),
);

// import EnterpriseCertification from '@/pages/EnterpriseCertification/index'
const EnterpriseCertification = lazy(() =>
  import('@/pages/EnterpriseCertification/index'),
);

// import EnterpriseInfo from '../pages/EnterpriseInfo/index'
const EnterpriseInfo = lazy(() => import('../pages/EnterpriseInfo/index'));

// import Agreement from '../pages/Agreement';
const Agreement = lazy(() => import('../pages/Agreement'));

// import PersonalCertificationDetail from '@/pages/PersonalCertificationDetail/index'
const PersonalCertificationDetail = lazy(() =>
  import('@/pages/PersonalCertificationDetail/index'),
);

// import CertificationComplete from '../pages/CertificationComplete';
const CertificationComplete = lazy(() =>
  import('../pages/CertificationComplete'),
);

// import EnterpriseCertificationDetail from '@/pages/EnterpriseCertificationDetail/index'
const EnterpriseCertificationDetail = lazy(() =>
  import('@/pages/EnterpriseCertificationDetail/index'),
);

// import ToLogin from '@/pages/ToLogin/index'
const ToLogin = lazy(() => import('@/pages/ToLogin/index'));

// import EnterpriseReplenish from '@/pages/EnterpriseReplenish/index'
const EnterpriseReplenish = lazy(() =>
  import('@/pages/EnterpriseReplenish/index'),
);

const EnterpriseReplenishSuccess = lazy(() =>
  import('@/pages/EnterpriseReplenishSuccess/index'),
);

const OrderConfirm = lazy(() => import('@/pages/OrderConfirm/index'));
// import EnterpriseConfirm from '@/pages/EnterpriseConfirm/index'
const routes = [
  {
    path: '/layout',
    component: Layout,
    //商城首页
    children: [
      {
        path: '/layout/ShoppingMall',
        component: ShoppingMall,
        title: '商城',
      },
    ],
  },
  //整车列表页
  {
    path: '/vehicle',
    component: Vehicle,
    title: '整车列表',
  },
  //整车详情页
  {
    path: '/detailsVehicle',
    component: DetailsVehicle,
    title: '商品详情',
  },
  //整车意向单页面
  {
    path: '/vehicleOrder',
    component: VehicleOrder,
    title: '商品意向单',
  },
  //后市场列表页
  {
    path: '/tyre',
    component: Tyre,
    title: '后市场列表',
  },
  //后市场详情页
  {
    path: '/detailsTyre',
    component: DetailsTyre,
    title: '商品详情',
  },
  //后市场意向单
  {
    path: '/tyreOrder',
    component: TyreOrder,
    title: '商品意向单',
  },
  //购物车
  {
    path: '/shopCar',
    component: ShopCar,
    title: '购物车',
  },
  //意向单申请成功
  {
    path: '/sucess',
    component: Sucess,
    title: '申请成功',
  },
  //OrderSucess
  //下单成功
  {
    path: '/orderSucess',
    component: OrderSucess,
    title: '下单成功',
  },
  //润滑油详情页
  {
    path: '/detailsLubricants',
    component: DetailsLubricants,
    title: '商品详情',
  },
  //润滑油意向单
  {
    path: '/lubricantsOrder',
    component: LubricantsOrder,
    title: '商品意向单',
  },
  //尿素详情页
  {
    path: '/detailsUrea',
    component: DetailsUrea,
    title: '商品详情',
  },
  //整车搜索页面
  {
    path: '/searchVehicle',
    component: SearchVehicle,
    title: '整车搜索',
  },
  //后市场搜索页面
  {
    path: '/searchTyre',
    component: SearchTyre,
    title: '后市场搜索',
  },
  //订单详情页面
  {
    path: '/orderDetails',
    component: OrderDetails,
    title: '订单详情',
  },
  //车辆参数确认页面
  {
    path: '/vehicleParameters',
    component: VehicleParameters,
    title: '商品参数',
  },
  // 意向单/订单列表
  {
    path: '/IntentionList',
    component: IntentionList,
    title: '我的意向单',
  },
  // 物流信息页面
  {
    path: '/logistics',
    component: Logistics,
    title: '物流信息',
  },
  //租金宝
  {
    path: '/rent',
    component: Rent,
    title: '租金宝',
  },
  //填写保单页
  {
    path: '/fill',
    component: Fill,
    title: '保单填写',
  },
  //租金宝申请成功
  {
    path: '/successTwo',
    component: SuccessTwo,
    title: '申请成功',
  },
  //金融页面
  {
    path: '/finance',
    component: Finance,
    title: '金融',
  },
  //德银保理页面
  {
    path: '/dyFactoring',
    component: DyFactoring,
    title: '德银保理',
  },
  //德银租赁页面
  {
    path: '/dylease',
    component: DyLease,
    title: '德银租赁',
  },
  //美信保险经纪
  {
    path: '/insurance',
    component: Insurance,
    title: '美信保险经纪',
  },
  //我的保单页
  {
    path: '/myPolicy',
    component: MyPolicy,
    title: '我的保单',
  },
  //历史保单
  {
    path: '/historyPolicy',
    component: HistoryPolicy,
    title: '历史保单',
  },
  // 我的订单
  {
    path: '/order',
    component: Order,
    title: '我的订单',
  },
  //修改表单信息页面
  {
    path: '/modifyInformation',
    component: ModifyInformation,
    title: '修改信息',
  },
  //理赔
  {
    path: '/settlementOfClaims',
    component: SettlementOfClaims,
    title: '理赔',
  },
  //申请理赔1
  {
    path: '/applyOne',
    component: ApplyOne,
    title: '申请理赔',
  },
  //申请理赔2
  {
    path: '/applyTwo',
    component: ApplyTwo,
    title: '申请理赔',
  },
  //理赔记录1
  {
    path: '/claimRecords',
    component: ClaimRecords,
    title: '理赔记录',
  },
  //保单详情页面
  {
    path: '/policyDetails',
    component: PolicyDetails,
    title: '保单详情',
  },
  //理赔申请成功页
  {
    path: '/successThree',
    component: SuccessThree,
    title: '申请成功',
  },
  //图片预览页面
  {
    path: '/imgShow',
    component: ImgShow,
    title: '图片预览',
  },
  //全局搜索
  {
    path: '/SearchAll',
    component: SearchAll,
    title: '搜索',
  },
  //理赔记录2
  {
    path: '/claimRecordsTwo',
    component: ClaimRecordsTwo,
    title: '理赔记录',
  },
  //驾意险上传图片一页面
  {
    path: '/basicInformation',
    component: basicInformation,
    title: '申请理赔',
  },
  //驾意险上传图片二页面
  {
    path: '/basicInformationTwo',
    component: basicInformationTwo,
    title: '申请理赔',
  },
  //驾意险
  {
    path: '/drivingInsurance',
    component: DrivingInsurance,
    title: '金融',
  },
  //驾意险详情
  {
    path: '/policyDetailsTwo',
    component: PolicyDetailsTwo,
    title: '保单详情',
  },
  //促销页面
  {
    path: '/promotion',
    component: Promotion,
    title: '国五促销',
  },
  //促销详情页
  {
    path: '/promotionDetail',
    component: PromotionDetail,
    title: '商品详情',
  },
  //参数配置页面
  {
    path: '/parameter',
    component: Parameter,
    title: '商品参数',
  },
  //低价活动促销页面
  {
    path: '/activity',
    component: Activity,
    title: '促销宣传',
  },
  // 隐私保护政策
  {
    path: '/privacy',
    component: Privacy,
    title: '隐私保护政策',
  },
  // 第三方sdk声明
  {
    path: '/SdkPage',
    component: SdkPage,
    title: '第三方信息共享清单',
  },
  //过年祝福
  {
    path: '/blessing',
    component: Bless,
    title: '车轮滚滚送祝福',
  },
  // 选择认证
  {
    path: '/CertificationOptions',
    component: CertificationOptions,
    title: '选择认证',
  },
  // 个人认证
  {
    path: '/PersonalCertification',
    component: PersonalCertification,
    title: '个人认证',
  },
  // 企业认证
  {
    path: '/EnterpriseCertification',
    component: EnterpriseCertification,
    title: '企业认证',
  },
  // 企业信息
  {
    path: '/EnterpriseInfo',
    component: EnterpriseInfo,
    title: '企业信息',
  },
  //电子签
  {
    path: '/agreement',
    component: Agreement,
    title: '电子签',
  },
  //实名认证完成
  {
    path: '/CertificationComplete',
    component: CertificationComplete,
    title: '认证完成',
  },
  // 个人实名认证详情
  {
    path: '/PersonalCertificationDetail',
    component: PersonalCertificationDetail,
    title: '个人认证信息',
  },
  // 企业实名认证详情
  {
    path: '/EnterpriseCertificationDetail',
    component: EnterpriseCertificationDetail,
    title: '个人认证信息',
  },
  // 登录中转
  {
    path: '/ToLogin',
    component: ToLogin,
    title: '去登陆',
  },
  //新的企业认证补录页面
  {
    path: '/enterpriseReplenish',
    component: EnterpriseReplenish,
    title: '企业认证',
  },
  //新的企业认证补录成功页面
  {
    path: '/enterpriseReplenishSuccess',
    component: EnterpriseReplenishSuccess,
    title: '企业认证',
  },
  //订单确认
  {
    path: '/orderConfirm',
    component: OrderConfirm,
    title: '订单确认',
  },
  //重定向
  {
    from: '/',
    to: '/layout/ShoppingMall',
    title: '商城',
  },
];

export default routes;
